import { RouteRoles } from '@/router/role-routes';
import { RouteConfig } from 'vue-router';
import { Loans } from './types';

const routes: RouteConfig[] = [
  {
    path: `/${Loans.Pages.LOANS}`,
    name: Loans.Pages.LOANS,
    component: () => import(/* webpackChunkName: "loans" */ './views/Loans.vue'),
    meta: {
      access_roles: RouteRoles[Loans.Pages.LOANS],
    },
  },
];

export default routes;
